"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing7xlarge = exports.spacing6xlarge = exports.spacing5xlarge = exports.spacing4xlarge = exports.spacing3xlarge = exports.spacing2xlarge = exports.spacingXlarge = exports.spacingLarge = exports.spacingMedium = exports.spacingSmall = exports.spacingXsmall = exports.spacingTiny = exports.spacingNone = exports.controlSpacing2xlarge = exports.controlSpacingXlarge = exports.controlSpacingLarge = exports.controlSpacingMedium = exports.controlSpacingSmall = exports.controlSpacingXsmall = exports.controlSpacingTiny = exports.controlSpacingNone = exports.actionSpacing2xlarge = exports.actionSpacingXlarge = exports.actionSpacingLarge = exports.actionSpacingMedium = exports.actionSpacingSmall = exports.actionSpacingXsmall = exports.actionSpacingTiny = exports.actionSpacingNone = exports.baseSpacing5xlarge = exports.baseSpacing4xlarge = exports.baseSpacing3xlarge = exports.baseSpacing2xlarge = exports.baseSpacingXlarge = exports.baseSpacingLarge = exports.baseSpacingMedium = exports.baseSpacingSmall = exports.baseSpacingXsmall = exports.baseSpacingTiny = exports.baseSpacingNone = void 0;
exports.baseSpacingNone = 0;
exports.baseSpacingTiny = 2;
exports.baseSpacingXsmall = 4;
exports.baseSpacingSmall = 8;
exports.baseSpacingMedium = 12;
exports.baseSpacingLarge = 16;
exports.baseSpacingXlarge = 20;
exports.baseSpacing2xlarge = 24;
exports.baseSpacing3xlarge = 32;
exports.baseSpacing4xlarge = 40;
exports.baseSpacing5xlarge = 48;
exports.actionSpacingNone = 0;
exports.actionSpacingTiny = 2;
exports.actionSpacingXsmall = 4;
exports.actionSpacingSmall = 8;
exports.actionSpacingMedium = 12;
exports.actionSpacingLarge = 16;
exports.actionSpacingXlarge = 20;
exports.actionSpacing2xlarge = 24;
exports.controlSpacingNone = 0;
exports.controlSpacingTiny = 2;
exports.controlSpacingXsmall = 4;
exports.controlSpacingSmall = 8;
exports.controlSpacingMedium = 12;
exports.controlSpacingLarge = 16;
exports.controlSpacingXlarge = 20;
exports.controlSpacing2xlarge = 24;
exports.spacingNone = 0;
exports.spacingTiny = 2;
exports.spacingXsmall = 4;
exports.spacingSmall = 8;
exports.spacingMedium = 12;
exports.spacingLarge = 16;
exports.spacingXlarge = 20;
exports.spacing2xlarge = 24;
exports.spacing3xlarge = 32;
exports.spacing4xlarge = 36;
exports.spacing5xlarge = 40;
exports.spacing6xlarge = 48;
exports.spacing7xlarge = 56;